import{styled as i}from"@mui/material/styles";const t=i("div")({img:{display:"block",width:40,height:40},svg:{display:"block"}});export{t as Icon};
//# sourceMappingURL=styles.js.map
